import { jsx as _jsx } from "react/jsx-runtime";
import { Theme as RadixTheme } from '@radix-ui/themes';
import { forwardRef } from 'react';
const Theme = forwardRef((props, forwardedRef) => {
    return _jsx(RadixTheme, { panelBackground: "solid", ...props, ref: forwardedRef });
});
Theme.displayName = 'Theme';
export { Theme };
//# sourceMappingURL=theme.js.map